var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 193 89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{opacity:0.75;mix-blend-mode:multiply;}.cls-3{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.07,
    y1: 101.31,
    x2: 153.1,
    y2: -17.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9afd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#cea9cf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#af98c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#998bc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#8c84be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8781bd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DESIGN_copy",
    "data-name": "DESIGN copy"
  }, /*#__PURE__*/React.createElement("image", {
    className: "cls-2",
    width: 193,
    height: 89,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.35,
    y: 6.02,
    width: 176.47,
    height: 71.56,
    rx: 8.49
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleBtn);
export default __webpack_public_path__ + "static/media/purpleBtn.254f4112e659214cb912e8ec1ac99e06.svg";
export { ForwardRef as ReactComponent };